module.exports = __webpack_public_path__ + "img/rocket.c39b446c.png";